﻿'use strict';

/*jslint bitwise: true */
angular.module('ntmApp')
  .filter('formatNumber', function () {
      return function (inputValue, decimalsNumber, roundUpToInt) {
          var formattedValue = inputValue;

          if (angular.isNumber(inputValue)) {

              if (roundUpToInt) {
                  formattedValue = Math.ceil(inputValue);
              } else {

                  if (angular.isNumber(decimalsNumber)) {
                      formattedValue = parseFloat(Number(inputValue + '').toFixed(parseInt(decimalsNumber)));
                  }
              }
          }

          return formattedValue;
      };
  });